export default [
  {
    path: "/backoffice/aid/chart-of-accounts",
    name: "ChartOfAccounts",
    meta: {
      requiresAuth: true, breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Accounts" },
      ]
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/Aid/SavingsAccountsList.vue"
      ),
  },
  {
    path: "/backoffice/aid/savings-accounts/:id",
    name: "SavingsAccountDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Accounts", to: "/backoffice/aid/chart-of-accounts" },
        { label: "AID Account Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/Aid/SavingsAccountDetail.vue"
      ),
  },
  {
    path: "/backoffice/aid/chart-of-accounts/create",
    name: "AddGLAccount",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Accounts", to: "/backoffice/aid/chart-of-accounts" },
        { label: "Add" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/Aid/AddGLAccount/AddGLAccount.vue"
      ),
  },
  {
    path: "/backoffice/aid/projects",
    name: "aidProjects",
    meta: {
      requiresAuth: true, breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Projects" },
      ]
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/AidProducts/AidProjectList.vue"
      ),
  },
  {
    path: "/backoffice/aid/projects/create",
    name: "aidProjectsCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Projects", to: "/backoffice/aid/projects" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/AidProducts/AidProjectCreate.vue"
      ),
  },
  {
    path: "/backoffice/aid/projects/:id",
    name: "aidProjectsEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Projects", to: "/backoffice/aid/projects" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/AidProducts/AidProjectCreate.vue"
      ),
  },
  {
    path: "/backoffice/aid/project-settings",
    name: "ProjectSettings",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "AID" },
        { label: "Project Settings" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "aid" */ "@/views/backoffice/Aid/ProjectSettings/ProjectSettings.vue"
      ),
  },
];
